import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { PasswordChangeForm } from "../../components/PasswordChange";
import { withAuthorization } from "../../components/Session/withAuthorization";
import { PasswordForgetForm } from "../PasswordForget/PasswordForgetForm";

const AccountComponent = ({ authUser }: any) => (
  <div>
    <h1>Account: {authUser.email}</h1>
    <PasswordForgetForm />
    <PasswordChangeForm />
  </div>
);

const mapStateToProps = (state: any) => ({
  authUser: state.sessionState.authUser,
});

const authCondition = (authUser: any) => !!authUser;

const Account = compose(
  withAuthorization(authCondition),
  connect(mapStateToProps)
)(AccountComponent);

export default Account;



// WEBPACK FOOTER //
// ./src/containers/Account/index.tsx